import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feed-block',
  templateUrl: './feed-block.component.html',
  styleUrls: ['./feed-block.component.css']
})
export class FeedBlockComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/AnnaNorbisrath/WebstormProjects/me.rainer.surfschule-wiesensee/src/app/feed-block/feed-block.component.ts